import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { App } from '@/components';
import { enableMocking } from '@/mocks';

import '@fontsource/manrope/latin-200.css';
import '@fontsource/manrope/latin-300.css';
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';
import '@fontsource/manrope/latin-800.css';
import '@fontsource/manrope/greek-200.css';
import '@fontsource/manrope/greek-300.css';
import '@fontsource/manrope/greek-400.css';
import '@fontsource/manrope/greek-500.css';
import '@fontsource/manrope/greek-600.css';
import '@fontsource/manrope/greek-700.css';
import '@fontsource/manrope/greek-800.css';
import '@/i18n';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE === 'production' ? 'production' : 'staging',
  enabled:
    import.meta.env.VITE_SENTRY_ENABLED === 'true' ||
    import.meta.env.MODE !== 'development',
});

enableMocking().then(() => {
  createRoot(document.getElementById('root') as HTMLElement).render(<App />);
});
